import { useRef, useEffect } from "react";
import * as d3 from "d3";

export default function MultiSizeCircles({ allUsers }) {
  const ref = useRef();

  //   append three values to each object in the array
  useEffect(() => {
    //   console.log(allUsers);
  }, [allUsers]);
  useEffect(() => {
    // Clear the #my_dataviz div
    d3.select("#my_dataviz").selectAll("svg").remove();

    allUsers.forEach((d) => {
      d.title = d.email;
      d.type = ["middle", "high"][Math.floor(Math.random() * 2)];
      d.value = Math.floor(Math.random() * 800) + 300;
      d.photoURL === null || d.photoURL === undefined
        ? (d.photoURL = `https://api.dicebear.com/7.x/adventurer/svg?seed=${d.email}&flip=true&radius=25&skinColor=ecad80,f2d3b1&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf,transparent`)
        : (d.photoURL = d.photoURL);
    });
    // set the dimensions and margins of the graph
    let width = window.innerWidth * 0.9; // 90% of viewport width
    let height = window.innerHeight * 0.8; // 80% of viewport height

    // append the svg object to the body of the page
    let svg = d3
      .select("#my_dataviz")
      .append("svg")
      .attr("width", width)
      .attr("height", height);

    // Size scale for transactions
    const size = d3.scaleLinear().domain([0, 2000]).range([7, 100]); // circle will be between 7 and 55 px wide

    // Add a resize event listener
    window.addEventListener("resize", resize);

    // Function to resize the SVG when the window is resized
    function resize() {
      // Update width and height
      width = window.innerWidth * 0.9;
      height = window.innerHeight * 0.8;

      // Apply new width and height to the SVG
      svg.attr("width", width).attr("height", height);
    }

    // Create a pattern for each image
    const defs = svg.append("defs");
    allUsers.forEach((d, i) => {
      const pattern = defs
        .append("pattern")
        .attr("id", `photoURL${i}`)
        .attr("width", 1)
        .attr("height", 1);

      pattern
        .append("image")
        .attr("href", d.photoURL)
        .attr("width", size(d.value) * 2)
        .attr("height", size(d.value) * 2)
        .attr("x", 0)
        .attr("y", 0)
        .style("filter", "drop-shadow(0px 0px 10px rgba(128,128,128,0.75))");
    });

    // Initialize the circle: all located at the center of the svg area
    var node = svg
      .append("g")
      .selectAll("circle")
      .data(allUsers)
      .join("circle")
      .attr("class", "node")
      .attr("r", (d) => size(d.value))
      .attr("cx", width)
      .attr("cy", height)
      .style("fill", (d, i) => `url(#photoURL${i})`)
      .style("fill-opacity", 0.8)
      .style("cursor", "pointer")
      .on("click", (event, d) => {
        window.location.href = `/myprofile/${d.id}`;
      });
    // Features of the forces applied to the nodes:
    const simulation = d3
      .forceSimulation()
      .force(
        "center",
        d3
          .forceCenter()
          .x(width / 2)
          .y(height / 2)
      ) // Attraction to the center of the svg area
      .force("charge", d3.forceManyBody().strength(0.1)) // Nodes are attracted one each other of value is > 0
      .force(
        "collide",
        d3
          .forceCollide()
          .strength(0.2)
          .radius(function (d) {
            return size(d.value) + 3;
          })
          .iterations(1)
      ); // Force that avoids circle overlapping

    // Apply these forces to the nodes and update their positions.
    // Once the force algorithm is happy with positions ('alpha' value is low enough), simulations will stop.
    simulation.nodes(allUsers).on("tick", function (d) {
      node.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
    });
    // });
  }, [allUsers]);

  return (
    <div ref={ref}>
      <div id="my_dataviz"></div>
    </div>
  );
}
